import { actionTypes } from './actions';

export const initialState = {
  languages: [],
  languagesV3: [],
};

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_LANGUAGES_SUCCESS: {
      const { languages } = action;
      return { ...state, languages };
    }

    case actionTypes.GET_LANGUAGES_V3_SUCCESS: {
      const { languagesV3 } = action;
      return { ...state, languagesV3 };
    }

    default:
      return state;
  }
};

export default languageReducer;
